import { render } from "./serviceSlider.vue?vue&type=template&id=4823b874"
import script from "./serviceSlider.vue?vue&type=script&lang=js"
export * from "./serviceSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__